import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { useState } from "react";
import { DialogAlert } from "../Components/DialogAlert";
import { addEspaceCharacters, constantes, instance } from "../Components/config";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useAuth } from "../Components/AuthContext";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { LoaderBox } from "../Components/LoaderBox";

function UPSE1Editar() {
  const { state } = useLocation();
  const { id } = state;
  const [responsable, setResponsable] = useState({ Id: "", Nombre: "" });
  const [tipoDeEje, setTipoDeEje] = useState({ Id: "", Nombre: "" });
  const [eje, setEje] = useState({ Id: "", Nombre: "" });
  const [isLoading, setLoading] = useState(true);
  const [fecha, setFecha] = useState();
  const [upseInfo, setUpseInfo] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const { user } = useAuth();
  const [dialog, setDialog] = useState({});

  if (isLoading) {
    instance
      .get(`/upse/getById/${id}`)
      .then((res) => {
        setUpseInfo(res.data);
        setTipoDeEje({ Id: upseInfo.tipoEjeId, Nombre: "" });
        setResponsable({ Id: upseInfo.responsableId, Nombre: "" });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally(
        setTimeout(() => {
          setLoading(false);
        }, 1000)
      );
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUpseInfo({ ...upseInfo, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      upse: id,
      id: user.id,
      nombre: addEspaceCharacters(info.nombre.value),
      responsable: responsable.Id,
      anio: info.anio.value,
      cooperacion: info.cooperacion.value,
      presupuesto: info.presupuesto.value,
      eje: eje.Id === "" ? upseInfo.ejeId : eje.Id,
      lugar: addEspaceCharacters(info.lugar.value),
      fecha: fecha ? fecha : new Date(upseInfo.fecha).toLocaleDateString("en-GB"),
      operativo: addEspaceCharacters(info.operativo.value),
      estreategico: addEspaceCharacters(info.estrategico.value),
    };
    instance
      .put("upse/", form)
      .then((res) => {
        console.log(res.data);
        setDialog({
          title: "Operación exitosa",
          text: "El UPSE ha sido actualizado exitosamente.",
          redirect: true,
          page: "/UPSE1",
          pageState: { id: id },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Box
        sx={{
          padding: "4px",
          margin: { xs: 0, sm: 8 },
          border: { xs: "0", sm: "1px solid #000" },
        }}
        component="form"
        onSubmit={handleSubmit}
      >
        <Grid
          container
          spacing={3}
          padding={2}
          rowSpacing={1}
          sx={{
            alignItems: "center",
          }}
        >
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="nombre"
              label="Nombre"
              name="nombre"
              inputProps={{ maxLength: 100 }}
              value={upseInfo.nombre}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <DatePicker
              views={["year"]}
              margin="standard"
              required
              fullWidth
              id="anio"
              label="Año que planifica"
              name="anio"
              format="YYYY"
              value={dayjs("01/01/" + upseInfo.anio)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl required>
              <FormLabel>Cooperación Externa</FormLabel>
              <RadioGroup
                row
                name="cooperacion"
                onClick={handleInputChange}
                value={String(upseInfo.cooperacion)}
              >
                <FormControlLabel value="1" control={<Radio />} label="Sí" />
                <FormControlLabel value="0" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <DropDownList
              required
              title="Responsable"
              endpoint={"/users/listActiveAndActual/"+upseInfo.responsableId}
              selectedItem={responsable}
              setSelectedItem={setResponsable}
              selected={upseInfo.responsableId}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="presupuesto"
              label="Techo presupuestario"
              name="presupuesto"
              type="number"
              inputProps={{
                step: constantes.decimales_dinero,
                min: 0,
                style: { textAlign: "right" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">Q</InputAdornment>
                ),
              }}
              value={upseInfo.presupuesto}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <DropDownList
              required
              title="Tipo de Eje"
              endpoint={"/tipoDeEje/listActiveAndActual/"+upseInfo.tipoEjeId}
              selectedItem={tipoDeEje}
              setSelectedItem={setTipoDeEje}
              selected={upseInfo.tipoEjeId}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <DropDownList
              required
              title="Eje"
              endpoint={
                tipoDeEje.Id !== ""
                  ? `/eje/listByTipoDeEjeAndActual/${tipoDeEje.Id}/${upseInfo.ejeId}`
                  : undefined
              }
              selectedItem={eje}
              setSelectedItem={setEje}
              disabled={tipoDeEje.Id === ""}
              hierarchyUpdated={tipoDeEje}
              selected={upseInfo.ejeId}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <DatePicker
              margin="normal"
              required
              fullWidth
              id="fecha"
              label="Fecha de presentación"
              name="fecha"
              format="DD/MM/YYYY"
              value={dayjs(upseInfo.fecha)}
              onChange={(newValue) =>
                setFecha(newValue.$d.toLocaleDateString("en-GB"))
              }
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="lugar"
              label="Lugar de presentación"
              name="lugar"
              inputProps={{ maxLength: 100 }}
              multiline
              value={upseInfo.lugar}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="operativo"
              label="Objetivo Operativo"
              name="operativo"
              inputProps={{ maxLength: 1000 }}
              value={upseInfo.operativo}
              onChange={handleInputChange}
              multiline
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="estrategico"
              label="Objetivo Estratégico"
              name="estrategico"
              inputProps={{ maxLength: 1000 }}
              value={upseInfo.estrategico}
              onChange={handleInputChange}
              multiline
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Box>
              <Button
                type="submit"
                variant="contained"
                color="success"
                sx={{ mt: 3, mb: 2 }}
                padding={1}
              >
                Actualizar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { UPSE1Editar };
